import React, { forwardRef, useImperativeHandle } from 'react';
import { MediaTypeEnum } from 'api';
import useStyles from './StyledDropZone.style';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Button, Container, Typography } from '@material-ui/core';

interface Props {
  mediaType: MediaTypeEnum;
  onSelectFile: (files: File[] | null, url?: string) => void;
  multiple: boolean;
}

export const StyledDropzone: React.FC<Props> = forwardRef(({ mediaType, onSelectFile, multiple }: Props, ref) => {
  const classes = useStyles();
  const MAX_VIDEO_SIZE = 4_294_967_296; // 4GB
  const MAX_IMAGE_SIZE = 8_388_608; // 8MB
  const MAX_FILE_SIZE_TEXT = `Maximum file size is ${mediaType === MediaTypeEnum.IMAGE ? '8MB' : '4GB'}`;
  const FILE_TYPE = mediaType === MediaTypeEnum.IMAGE ? 'image/*' : ['video/*', 'image/gif'];
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    maxSize: mediaType === MediaTypeEnum.IMAGE ? MAX_IMAGE_SIZE : MAX_VIDEO_SIZE,
    multiple: multiple,
    noKeyboard: true,
    accept: FILE_TYPE,
    onDrop: (acceptedFiles) => {
      onSelectFile(acceptedFiles);
    }
  });

  useImperativeHandle(ref, () => ({
    openUploadDialog() {
      open();
    }
  }));

  return (
    <Container classes={{ root: classes.baseStyle }} {...getRootProps({})}>
      <input {...getInputProps()} />

      <Button size="small" onClick={open} color="primary" variant="contained" endIcon={<CloudUploadIcon />}>
        Select {mediaType}
        {multiple ? 's' : ''}
      </Button>

      <Typography classes={{ root: classes.warning }}>{MAX_FILE_SIZE_TEXT}</Typography>
      {multiple && <Typography classes={{ root: classes.warning }}>You can upload up to 10 images at once.</Typography>}
    </Container>
  );
});
